import React, { useState } from "react"
import Input from "aldoo-ra/Input"
import Button from "aldoo-ra/Button"
import Modal from "aldoo-ra/Modal"
import Typography from "aldoo-ra/Typography"
import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline"

const SendingRateInputEditor = ({ value, onChange, field, variant = "admin" }) => {
  const [showHelpModal, setShowHelpModal] = useState(false)

  const handleChange = (e) => {
    const numValue = Number(e.target.value)
    onChange(numValue)
  }

  return (
    <div>
      <div className="flex gap-2 items-start">
        <div className="flex-1">
          <Input
            type="number"
            value={value || 100}
            onChange={handleChange}
            variant={variant}
            min={field?.validation?.min || 1}
            max={field?.validation?.max || 10000}
          />
        </div>
        <Button
          variant="admin_secondary"
          onClick={() => setShowHelpModal(true)}
          className="flex-shrink-0"
        >
          <QuestionMarkCircleIcon className="w-5 h-5 mr-2" />
          How to Select Rates
        </Button>
      </div>

      <Modal
        isOpen={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        variant="admin_compact"
        //Overriding max-h to eliminate double scrollbars on smaller screens
        styleOverrides={{
          container:
          "bg-admin_paper max-h-full md:max-h-[calc(95vh)] scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper overflow-y-auto md:rounded-md border border-admin_bordered shadow-lg w-full max-w-[50%] p-0 m-0",
        }}
      >
        <div className="p-4">
          <Typography 
            component="h1"
            variant="admin_h4" 
            className="mb-4"
          >
            How to Select Email Sending Rates
          </Typography>

          <div className="space-y-3 text-admin_text text-sm max-h-[60vh] overflow-y-auto scrollbar-thin scrollbar-thumb-admin_neutral_2 scrollbar-track-admin_paper">
            <div>
              <Typography variant="admin_label">
                📊 New Account Limits
              </Typography>

              <ul className="list-disc list-inside space-y-0.5 pl-6">
                <li className="my-0.5">
                  New SparkPost accounts: <strong>1,000 emails/day</strong>
                </li>
                <li>Limits grow over first week</li>
                <li>Hourly limits based on rolling 24hr windows</li>
              </ul>
            </div>

            <div>
              <Typography variant="admin_label">
                🔥 IP Warm-up Process
              </Typography>

              <ul className="list-disc list-inside space-y-0.5 pl-6">
                <li className="my-0.5">Start with low volumes (hundreds/day)</li>
                <li>Gradually increase over 4-6 weeks</li>
                <li>Monitor bounce rates and engagement</li>
                <li>
                  <a
                    href="https://support.sparkpost.com/docs/deliverability/ip-warm-up-overview"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-admin_link hover:underline"
                  >
                    SparkPost IP Warm-up Guide →
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <Typography variant="admin_label">
                ⚙️ Rate Recommendations
              </Typography>

              <ul className="list-disc list-inside space-y-0.5 pl-6">
                <li className="my-0.5"><strong>New accounts:</strong> 100/hour (default)</li>
                <li><strong>Growing limits:</strong> Gradually increase</li>
                <li><strong>50k+/day:</strong> Requires dedicated IPs</li>
              </ul>
            </div>

            <div>
              <Typography variant="admin_label">
                ✅ Best Practices
              </Typography>

              <ul className="list-disc list-insidespace-y-0.5 pl-6">
                <li className="my-0.5">Leave buffer room, don't max out</li>
                <li>Monitor SparkPost dashboard metrics</li>
                <li>Watch bounces and complaints</li>
                <li>Maintain consistent patterns</li>
              </ul>
            </div>

            <div className="bg-admin_canvas p-2 rounded text-admin_text_secondary">
              <span className="text-admin_text font-semibold">💡 Tip:</span> Check SparkPost dashboard for your current limits
            </div>
          </div>

          <div className="mt-4 flex justify-end">
            <Button
              variant="admin_secondary"
              onClick={() => setShowHelpModal(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SendingRateInputEditor
